import type AttributesObserver from "@ui-utils/AttributesObserver/AttributesObserver";
import type { Observable } from "rxjs";
import { BehaviorSubject, map } from "rxjs";

import type { ProductIdProviderInterface } from "./ProductIdProviderInterface";

export class ProductIdFromAttributeProvider
    implements ProductIdProviderInterface
{
    private readonly productId$ = new BehaviorSubject<number | null>(null);

    constructor(
        private readonly observer: AttributesObserver,
        private readonly element: HTMLElement,
        private readonly attributeName: string
    ) {
        this.observer
            .observe(this.element, this.attributeName)
            .pipe(map((value) => Number(value) || null))
            .subscribe(this.productId$);
    }

    selectProductId(): Observable<number | null> {
        return this.productId$;
    }
}
